import { Component } from '@angular/core';
import { getNestedValue } from '../../util/table-v2.utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@ngx-translate/core";
/**
 * @deprecated use v3 version of this component instead
 */
function TranslationRendererComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ((tmp_1_0 = ctx_r0.config == null ? null : ctx_r0.config.prefix) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "") + ctx_r0.getNestedValue(ctx_r0.rowData, ctx_r0.columnKey) + ((tmp_1_0 = ctx_r0.config == null ? null : ctx_r0.config.suffix) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "")), " ");
  }
}
export class TranslationRendererComponent {
  rowData;
  columnKey;
  config;
  getNestedValue = getNestedValue;
  static ɵfac = function TranslationRendererComponent_Factory(t) {
    return new (t || TranslationRendererComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TranslationRendererComponent,
    selectors: [["geaui-translation-renderer"]],
    decls: 1,
    vars: 1,
    consts: [[4, "ngIf"], [1, "translation"]],
    template: function TranslationRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, TranslationRendererComponent_ng_container_0_Template, 4, 3, "ng-container", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.rowData);
      }
    },
    dependencies: [i1.NgIf, i2.TranslatePipe],
    styles: [".translation[_ngcontent-%COMP%]{overflow:hidden}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationRendererComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-translation-renderer',
      template: "<ng-container *ngIf=\"rowData\">\n  <div class=\"translation\">\n    {{ (config?.prefix ?? '') + getNestedValue(rowData, columnKey) + (config?.suffix ?? '') | translate }}\n  </div>\n</ng-container>\n",
      styles: [".translation{overflow:hidden}\n"]
    }]
  }], null, null);
})();
